import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import CoursesListItem from './CoursesListItem';
import CoursesDetails from './details/CoursesDetails';
import events from './CoursesEvents';

import buttons from './CoursesButtons';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('courses'),
	routes: [
		{
			path: 'tickets/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'courses'),
			element: (
				<DetailsPage
					key="courses/add"
					module="courses"
					headerOptions={{ showAvatar: true }}
					tabs={CoursesDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},

		{
			path: 'courses/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'courses'),
			element: (
				<DetailsPage
					key="courses/details"
					module="courses"
					headerOptions={{ showAvatar: true }}
					tabs={CoursesDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'courses/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'courses'),
			element: (
				<ViewPage
					key="courses/view"
					module="courses"
					content={{ type: 'list', itemLayout: CoursesListItem, id: 'coursesView' }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
